// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3gj6F","footer":"Form_footer__3wXCX"};